import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// Vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
// i18n
import { i18n } from "@/plugins/i18n"
// Google Auth
import GAuth from 'vue-google-oauth2'
const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  scope: 'profile email openid',
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)

Vue.config.productionTip = false

Vue.prototype.$config = {
  "MODE": "SUPERLIGA"
}

function LoadApp() {
  window.mainApp = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

if(window['cordova'])
{
  document.addEventListener('deviceready', LoadApp, false)
}
else
{
  LoadApp();
}